<template>
  <div class="collections container">
    <div v-if="(isindex&&title)||!isindex">
      <h1 class="title_font">{{ title|| $t('productList.catalog') }}</h1>
      <v-line></v-line>
    </div>
    <div class="row collectionstop" v-if="this.cates.length">
      <div
        v-for="(item,index) in cates"
        :key="index"
        :class="[
                { 'col-12 collectionstopitem only_item':cates.length==1},
                { 'col-6 collectionstopitem':cates.length%2==0&&cates.length<=4},
                { 'col-sm-4 col-6 collectionstopitem':cates.length%3==0},
                { 'col-sm-4 col-12 collectionstopitem':cates.length%3==0&&cates.length%2==1&&index==0},
                { 'col-sm-6 col-12 collectionstopitem':cates.length%3==1&&cates.length%2==1&&cates.length>4&&index==0},
                { 'col-6  collectionstopitem':cates.length%3==1&&cates.length%2==0&&cates.length>4&&index==0},
                { 'col-6 collectionstopitem':cates.length%3==1&&cates.length>4&&index<4},
                { 'col-sm-4 col-6 collectionstopitem':cates.length%3==1&&cates.length>4&&index>=4},
                { 'col-6 collectionstopitem':cates.length%3==2&&cates.length>4&&index==1},
                { 'col-sm-6  col-12 collectionstopitem':cates.length%3==2&&cates.length>4&&cates.length%2==1&&index==0},
                { 'col-6 collectionstopitem':cates.length%3==2&&cates.length>4&&cates.length%2==0&&index==0},
                { 'col-sm-4 col-6  collectionstopitem':cates.length%3==2&&cates.length>4&&index>1},
        ]"
      >
        <!-- {
        只有一条的时候不论大小都为col-12,
        只有2条和4条的时候都为col-6,
        3的倍数时大屏col-4，小屏col-6,
        3的倍数时并且奇数的话第一个小屏要为col-12
        3余1并且总数大于4时第一个大屏6小屏12
        3余1并且总数大于4时前4个不论大小都为6
        3余1并且总数大于4时4以后的大4 小6
        3余2并且总数大于4时第2个不论大小为6
        3余2并且总数大于4时且为奇数时候第一个大6小12
        3余2并且总数大于4时且为偶数时候第一个不论大小都为6
        3余2并且总数大于4时第二个以后大4小6
        }-->
        <a :href="'/collections/'+item.term.slug">
          <div class="lazyload" :data-bg="item.thumbnail_url"></div>

          <!-- <div :style="'background-image:url('+item.thumbnail_url+')' "></div> -->
          <span class="secondary_title">{{item.term.name}}</span>
        </a>
      </div>
    </div>
    <div
      v-else
    >{{$t('home.not_include_content')}}</div>
  </div>
</template>
<script>
export default {
  props: ["cates", "title", "isindex", "last_sale"],
  data() {
    return {};
  },
  mounted() {
    document.addEventListener("lazybeforeunveil", function(e) {
      var bg = e.target.getAttribute("data-bg");
      if (bg) {
        e.target.style.backgroundImage = "url(" + bg + ")";
      }
    });
    console.log("产品分类", this.cates);
  }
};
</script>
<style scoped lang='scss'>
.collections {
  text-align: center;
  h1 {
    margin-top: 16px;
    font-size: 26px;
  }
  .collectionstop {
    .collectionstopitem {
      padding-bottom: 30px;
      a {
        display: block;
        width: 100%;
        height: 100%;
        position: relative;
        text-decoration: none;
        overflow: hidden;

        &:hover {
          div {
            transform: scale(1.05);
            &:after {
              opacity: 0.5;
            }
          }
        }

        div {
          height: 310px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          transition: all 0.8s;
          -webkit-transition: all 0.8s;
          -moz-transition: all 0.8s;
          -ms-transition: all 0.8s;
          -o-transition: all 0.8s;
          &:after {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            opacity: 0.25;
            background-color: #000;
            transition: all 0.8s;
            -webkit-transition: all 0.8s;
            -moz-transition: all 0.8s;
            -ms-transition: all 0.8s;
            -o-transition: all 0.8s;
          }
        }

        span {
          width: 100%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 30px;
          font-weight: 400;
          overflow: hidden;
        }
      }
    }
    .only_item{
      a{
        div{
          height: 450px;
        }
      }
    }
  }
}

@media screen and (max-width: 576px) {
  .collections {
    .collectionstop {
      & > .collectionstopitem {
        padding: 0 7.5px 20px;

        a {
          div {
            height: 190px !important;
          }
          span{
            padding: 0;
            font-size: 26px;
          }
        }
      }

      //     .collectionstopitem {
      //       padding-bottom: 15px;
      //       a {
      //         div {
      //           height: 130px !important;
      //         }
      //       }
      //     }
      //     & > .collectionstopitem:nth-child(odd) {
      //       padding-left: 7.5px;
      //     }
      //     & > .collectionstopitem:first-child {
      //       padding-left: 15px;
      //     }
      //     & > .collectionstopitem:nth-child(even) {
      //       padding-right: 7.5px;
      //     }
    }
  }
}
</style>